/**
 * GinType
 */
export type GinType = 'DISTILLED_GIN' | 'LONDON_GIN' | 'DUTCH_GIN';

export const GinType = {
  DistilledGin: 'DISTILLED_GIN' as GinType,
  LondonGin: 'LONDON_GIN' as GinType,
  DutchGin: 'DUTCH_GIN' as GinType,
};
